import PropTypes from "prop-types"

export default function InfoHeader({ showSizeColumn }) {
  return (
    <div className="info-header-row">
      <span />
      <span className="value">Equity %</span>
      {showSizeColumn && <span className="value">Size</span>}
    </div>
  )
}

InfoHeader.propTypes = {
  showSizeColumn: PropTypes.bool,
}
